import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { DefaultTheme } from "styled-components/native";
import tokens from "../../../vdb-tokens.json";
import { generateThemeTokens } from "@utils/design-tokens";

const theme = generateThemeTokens(tokens.global, tokens.global, {});

export const DEFAULT_THEME: DefaultTheme = theme;

// TODO: Set the theme type when we have the theme properties defined
export const themeSlice = createSlice({
  name: "theme",
  initialState: DEFAULT_THEME,
  reducers: {
    setTheme: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setTheme } = themeSlice.actions;

// TODO: Add type when we define themes
export const useThemeStore = () => useSelector((state: any) => state.theme);

export default themeSlice.reducer;
